// const urlName = '/monitor/monitor/v1/ai'
const urlName = '/monitor/v1/ai'


export default API => ({
    postcamera({ params, data }) {
        return API({ url: `monitor/v1/humanFace/comparison`, method:'post', params, data });
    },
    faceverify({ params, data }) {
        return API({ url: `${urlName}/oauth/faceverify`, method:'post', params, data});
    },
    idcardAffirm({ params, data }) {
        return API({ url: `${urlName}/oauth/idcardAffirm`, method:'post', params, data});
    },
    //配置项配置是否校验：是->（商联会）先校验登录人姓名身份证号和实名的是否一致，再去调用监控模块接口
    slhIdcardAffirm({ params, data }) {
        return API({ url: `/slh/v1/houseKeeper/idcardAffirm`, method:'post', params, data});
    },
    idcardDiscern({ params, data }) {
        return API({ url: `${urlName}/oauth/idcardDiscern`, method:'post', params, data});
    },
    getvirefytoken({ params, data }) {
        return API({ url:`${urlName}/token/getVerifyToken`, method:'post', params, data });
    },
    getprivacyPolicy() {
        return API({ url:`/resource/v1/privacyPolicy/getPrivacyPolicy?id=1`});
    },
    // 山东应急 人脸识别
    taskUserAuthRecord({data,params}) {
        return API(
          { 
            url:`/saas/v1/taskUserAuthRecord/save`,
            method:'post',
            data,
            params
          });
    },
    
})